export * from './primitive-year-month-pagination.component';
export * from './primitive-year-month-pagination.module';
